import {
  Box,
  chakra,
  Flex,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Icon,
} from '@chakra-ui/react';
import { Text, TextField } from '@diamond/shared/ui';
import { EditOutlined, LocationOnOutlined } from '@mui/icons-material';
import { FieldErrors, useFormContext } from 'react-hook-form';

type ShipToContactFieldName = 'name' | 'telp';
interface ShipToContactErrors {
  ship_to: {
    address: string;
  };
  ship_to_contact?: Record<
    ShipToContactFieldName,
    { message: string } | string
  >;
}

export function ShippingAddress() {
  const {
    register,
    formState: { errors },
    trigger,
    setValue,
  } = useFormContext<ShipToContactErrors>();

  const handleTelpInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const trimmedValue = value.slice(0, 14);
    setValue('ship_to_contact.telp', trimmedValue);
    trigger('ship_to_contact.telp');
  };

  return (
    <Box
      flex="1"
      border="1px"
      borderColor="gray.33"
      shadow="base"
      px="4"
      py="6"
      rounded="lg"
    >
      <Flex>
        <Flex justifyContent="center" alignItems="center" mr="2">
          <Icon as={LocationOnOutlined} color="blue" boxSize={8} />
        </Flex>
        <Box>
          <Text fontSize="20px" fontWeight="bold">
            Alamat Pengiriman
          </Text>
        </Box>
      </Flex>
      <Grid
        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
        gap={6}
        mt="6"
      >
        <GridItem colSpan={{ base: 0, md: 2 }}>
          <TextField
            name="ship_to.address"
            label="Alamat Lengkap"
            size="md"
            rounded="lg"
            register={register}
            isDisabled
          />
        </GridItem>
        <GridItem colSpan={{ base: 0, md: 2 }}>
          <Flex direction={['column', 'column', 'row']} gap="4">
            <Box flex="1">
              <FormLabel
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                w="full"
                aria-label="Nama Pemesan"
                htmlFor="ship_to_contact.name"
              >
                <Box>
                  Nama Pemesan
                  <chakra.span fontSize="sm" color="red">
                    *
                  </chakra.span>
                </Box>
                <Icon as={EditOutlined} color="gray.75" boxSize={6} />
              </FormLabel>
              <TextField
                id="ship_to_contact.name"
                name="ship_to_contact.name"
                size="md"
                rounded="lg"
                register={register}
                onInput={() => trigger('ship_to_contact.name')}
                extra={renderShipToContactError(errors, 'name')}
              />
            </Box>
            <Flex flex="1" direction={'column'} gap={2}>
              <Box>
                <FormLabel
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  w="full"
                  aria-label="Nomor HP"
                  htmlFor="ship_to_contact.telp"
                >
                  <Box>
                    Nomor HP
                    <chakra.span fontSize="sm" color="red">
                      *
                    </chakra.span>
                  </Box>
                  <Icon as={EditOutlined} color="gray.75" boxSize={6} />
                </FormLabel>
                <TextField
                  id="ship_to_contact.telp"
                  name="ship_to_contact.telp"
                  size="md"
                  rounded="lg"
                  register={register}
                  onInput={handleTelpInput}
                  extra={renderShipToContactError(errors, 'telp')}
                />
              </Box>
              <Text color="gray.75" fontSize="12px" textAlign="justify">
                Masukkan nomor HP aktif, CS akan menghubungi jika ada perubahan
                pesanan.
              </Text>
            </Flex>
          </Flex>
        </GridItem>
      </Grid>
    </Box>
  );
}

function renderShipToContactError(
  errors: FieldErrors<ShipToContactErrors>,
  fieldName: ShipToContactFieldName
) {
  const fieldError = errors.ship_to_contact?.[fieldName];
  return fieldError ? (
    <FormErrorMessage textColor="red">
      {fieldError['message'] as string}
    </FormErrorMessage>
  ) : null;
}
